export default {
  data() {
    return {
      fetched: false,
      nextLink: "",
      previousLink: "",
      paginationInfo: "",
      queryParams: {},
      fetchedData: [],
      response: {}
    };
  },
  computed: {
    filtered() {
      return Object.keys(this.queryParams).length > 0;
    }
  },
  watch: {
    fetchAPI() {
      this.fetchData();
    },
    queryParams: {
      handler: function() {
        this.fetchData();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fetched = false;
      const params = this.queryParams;
      this.$axios.$get(this.fetchAPI, { params }).then(response => {
        this.response = response;
        this.fetchedData = response.results;
        this.nextLink = this.getSecureURL(response.next);
        this.previousLink = this.getSecureURL(response.previous);
        this.paginationInfo = this.calculatePaginationInfo(response);
        this.fetched = true;
      });
    },
    getSecureURL(urlLink) {
      if (urlLink) {
        const link = new URL(urlLink);
        if (
          process.env.NODE_ENV === "production" &&
          link.protocol === "http:"
        ) {
          link.protocol = "https:";
          return link.href;
        }
      }
      return urlLink;
    },
    calculatePaginationInfo(response) {
      const totalCount = response.count;
      if (response.next) {
        const link = new URL(response.next);
        this.toCount = link.searchParams.get("offset");
      } else {
        this.toCount = totalCount;
      }
      if (!response.previous) {
        this.fromCount = 0;
      } else {
        this.fromCount = this.toCount - response.results.length;
      }
      this.fromCount += 1;
      if (response.count === 0) {
        this.fromCount = 0;
      }
      return this.fromCount + " - " + this.toCount + " of " + totalCount;
    }
  }
};
